export const SheetEvent = Object.freeze({
  CLOSE: "sheet_close",
});
